export default __webpack_public_path__ + "static/media/clock-regular.d08b76e0.svg";